import { Injectable, EventEmitter, Output } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { VwTaskMatConsItem } from '../viewdto/vwTaskMatConsItem';
import { RequestResult } from '@app/core/dto/RequestResult';
import { MaterialItem, VwMaterialList } from '../dto/Material';
import {of} from 'rxjs'

@Injectable({
  providedIn: 'root'
})



export class MaterialService {

  apiServer = environment.apiHost + environment.apiPort;

  constructor(public http: HttpClient) { }

  loadAll(subscriber: string, hotelId: number) {

   return this.http.get(this.apiServer + '/api/kip/Materials/LoadAll/' + subscriber + "/" + hotelId);
  }

  loadTaskMaterials(subscriber : string, hotelId: number, dailyTypeId: number) {
    return this.http.get(this.apiServer + '/api/kip/Materials/LoadTaskMaterials/' + subscriber + "/" + hotelId + "/" + dailyTypeId);

  }
  addTaskMaterials(subscriber: string, hotelId: number, dailyTypeId: number, data: VwTaskMatConsItem[]) {
     const headers = new HttpHeaders().set("Content-Type", "application/json"); 
     return this.http.put(this.apiServer + '/api/kip/Materials/AddTaskMaterials/' + subscriber + "/" + hotelId + "/" + dailyTypeId,data,{headers})
  }
}